// extracted by mini-css-extract-plugin
export default {"footer-container":"Footer_footer-container__S92qH","footer-column":"Footer_footer-column__O9jku","category-headings":"Footer_category-headings__mYXRL"};